import { useEffect } from 'react';

declare global {
  interface Window {
    Tawk_API?: Record<string, unknown>;
    Tawk_LoadStart?: Date;
  }
}

const TAWKTO_PROJECT_ID =
  process.env.REACT_APP_TAWKTO_PROJECT_ID ?? '69b016cd8c77691c35505679';
const TAWKTO_WIDGET_ID = process.env.REACT_APP_TAWKTO_WIDGET_ID ?? '1jjbti4u8';
const TAWKTO_SCRIPT_ID = 'tawkto-widget-script';

export function TawkToWidget() {
  useEffect(() => {
    if (
      typeof window === 'undefined' ||
      !TAWKTO_PROJECT_ID ||
      !TAWKTO_WIDGET_ID ||
      // never load the widget inside the Paystack payment callback iframe
      window.location.pathname.includes('payment-successful')
    ) {
      return;
    }

    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    if (document.getElementById(TAWKTO_SCRIPT_ID)) {
      return;
    }

    const script = document.createElement('script');
    const firstScriptTag = document.getElementsByTagName('script')[0];

    script.id = TAWKTO_SCRIPT_ID;
    script.async = true;
    script.src = `https://embed.tawk.to/${TAWKTO_PROJECT_ID}/${TAWKTO_WIDGET_ID}`;
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');

    if (firstScriptTag?.parentNode) {
      firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
      return;
    }

    document.body.appendChild(script);
  }, []);

  return null;
}
